import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import CardCompanyAvatar from '@atoms/CardCompanyAvatar';
import BaseCard from '@molecules/BaseCard';
import getFavoriteHook from '@hooks/getFavoriteHook';

const CompanyCardRedesign = ({
    id,
    name,
    displayLocation,
    businessType,
    url,
    logoUrl,
    isFavorite: initialIsFavorite,
    showShareIcon = false,
    onClick,
}) => {
    const history = useHistory();

    // TODO: Use FavoriteButtonCompany
    const useFavorite = getFavoriteHook({ type: 'company', initialIsFavorite });
    const { isFavorite, isLoadingFavorite, saveFavorite, removeFavorite, setIsFavoriteManually } = useFavorite();

    useEffect(() => {
        setIsFavoriteManually(initialIsFavorite);
    }, [initialIsFavorite, setIsFavoriteManually]);

    const goToProfile = e => {
        // History is undefined if called from within a modal
        if (!history) {
            return;
        }

        e.preventDefault();
        history.push(url, { inApp: true });
    };

    const onFavorite = () => {
        if (isFavorite) {
            removeFavorite(id);
        } else {
            saveFavorite(id);
        }
    };

    return (
        <BaseCard
            id={id}
            type="company"
            title={name}
            url={url}
            onClick={onClick}
            isFavorite={isFavorite}
            onFavorite={onFavorite}
            isLoadingFavorite={isLoadingFavorite}
            showShareIcon={showShareIcon}
            imageBlock={
                <div className="d-flex justify-content-center mt-4 mt-lg-5 mx-auto">
                    <CardCompanyAvatar photoURL={logoUrl} />
                </div>
            }
            contentBlock={
                <>
                    <a
                        href={url}
                        onClick={e => {
                            onClick(url);
                            goToProfile(e);
                        }}
                        onKeyDown={e => {
                            onClick(url);
                            goToProfile(e);
                        }}
                        className="profile-name-link"
                    >
                        <h3 className="member-name mt-3 mb-0 display6 bold text-center">{name}</h3>
                    </a>

                    {businessType && businessType.length > 0 && (
                        <p className="display8 secondary mt-2 mb-0 text-center member-title">{businessType[0]}</p>
                    )}

                    <p className="display8 secondary mt-2 mb-0 text-center member-title">{displayLocation}</p>
                </>
            }
        />
    );
};

CompanyCardRedesign.propTypes = {
    id: PropTypes.any.isRequired,
    name: PropTypes.string,
    displayLocation: PropTypes.string,
    businessType: PropTypes.array.isRequired,
    url: PropTypes.string,
    logoUrl: PropTypes.string,
    isFavorite: PropTypes.bool.isRequired,
    showShareIcon: PropTypes.bool,
    onClick: PropTypes.func,
};

export default CompanyCardRedesign;
